const AUTH_DEBUG_QUERY_PARAM = 'auth_debug';

const isAuthDebugQueryEnabled = (): boolean => {
  if (typeof window === 'undefined') return false;

  try {
    const params = new URLSearchParams(window.location.search);
    const value = params.get(AUTH_DEBUG_QUERY_PARAM);
    return value === '1' || value === 'true';
  } catch {
    return false;
  }
};

const isAuthDebugEnabled = (): boolean => {
  const envEnabled = import.meta.env.VITE_AUTH_DEBUG === 'true';
  return envEnabled || isAuthDebugQueryEnabled();
};

const AUTH_DEBUG_PREFIX = '[AuthDebug]';

export const authDebugInfo = (message: string, details?: unknown): void => {
  if (!isAuthDebugEnabled()) return;
  if (details !== undefined) {
    console.info(`${AUTH_DEBUG_PREFIX} ${message}`, details);
    return;
  }
  console.info(`${AUTH_DEBUG_PREFIX} ${message}`);
};

export const authDebugWarn = (message: string, details?: unknown): void => {
  if (!isAuthDebugEnabled()) return;
  if (details !== undefined) {
    console.warn(`${AUTH_DEBUG_PREFIX} ${message}`, details);
    return;
  }
  console.warn(`${AUTH_DEBUG_PREFIX} ${message}`);
};

export const redactValue = (value: string | null): string => {
  if (!value) return 'missing';
  return `len:${value.length}`;
};

export const redactClientId = (clientId: string): string => {
  if (!clientId) return 'missing';
  if (clientId.length <= 6) return `${clientId.slice(0, 2)}***`;
  return `${clientId.slice(0, 4)}***${clientId.slice(-2)}`;
};
